import { EnvConfig } from './apiConfig'
const commonConfig = {}

export default commonConfig as EnvConfig
